import { connect } from 'react-redux'
import { setAoLPreferenceModalOpen, setAoLPreferenceModalDismissedForSession } from 'redux/actions/modals'
import AoLPreferenceModal from 'components/account/AoLPreferenceModal'
import { RootState, AppDispatch } from 'redux/store'
import { AOL_MODAL_ENABLED } from 'constants/feature-flags'
import selectHasAol from 'redux/selectors/selectHasAol'
import selectIsLogged from 'redux/selectors/selectIsLogged'

export const mapStateToProps = (state: RootState): { isOpen: boolean, needsSetup: boolean } => {
  const { isOpen: manuallyOpened, dismissedForSession } = state.modals.aolPreference
  const showAolModal = state.user?.primaryAolSetByUser === false && selectIsLogged(state) && selectHasAol(state) && !dismissedForSession

  return {
    isOpen: AOL_MODAL_ENABLED && (manuallyOpened || showAolModal),
    needsSetup: AOL_MODAL_ENABLED && showAolModal
  }
}

const mapDispatchToProps = (dispatch: AppDispatch): { setAoLPreferenceModalOpen: (isOpen: boolean) => void, dismissAoLPreferenceModalForSession: () => void } => ({
  setAoLPreferenceModalOpen: (isOpen: boolean) => dispatch(setAoLPreferenceModalOpen(isOpen)),
  dismissAoLPreferenceModalForSession: () => dispatch(setAoLPreferenceModalDismissedForSession())
})

export default connect(mapStateToProps, mapDispatchToProps)(AoLPreferenceModal)
